import {giveInitialData} from "../../actions/schemaActions";

const dispatchInitialData = (component) => {
  let initialData = component.props.initialData ? component.props.initialData : {};
  component.props.dispatch(giveInitialData(component.props.id, initialData));
};

export default dispatchInitialData;